import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { Button } from "@material-ui/core";
import axios from "axios";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useSessionModal } from "../../../contexts/SessionModalContext";
import {
    NODE_API_URL,
} from "./../../../env_config";
import { Aside } from "./aside/Aside";
import { QuickUser } from "./extras/offcanvas/QuickUser";
import { ScrollTop } from "./extras/ScrollTop";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Header } from "./header/Header";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
import { IoIosWarning } from "react-icons/io";

export function Layout({ children, language, themeData, translationsVersion }) {
    const location = useLocation();
    const history = useHistory();

    const {
        consumerSessionDetails,
    } = useSelector((state) => state.CcmodeConsumerSessionReducer);

    const { openSessionModal } = useSessionModal();

    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            selfLayout: objectPath.get(uiService.config, "self.layout"),
            asideDisplay: objectPath.get(
                uiService.config,
                "aside.self.display"
            ),
            subheaderDisplay: objectPath.get(
                uiService.config,
                "subheader.display"
            ),
            desktopHeaderDisplay: objectPath.get(
                uiService.config,
                "header.self.fixed.desktop"
            ),
            contentCssClasses: uiService.getClasses("content", true),
            contentContainerClasses: uiService.getClasses(
                "content_container",
                true
            ),
            contentExtended: objectPath.get(
                uiService.config,
                "content.extended"
            ),
        };
    }, [uiService]);

    const userData = useMemo(() => localStorage.getItem("userData"), []);
    const user = JSON.parse(userData);
    const id = useMemo(() => localStorage.getItem("C_id"), []);
    const consumerSessionId = useMemo(
        () => JSON.parse(localStorage.getItem("consumerSessionId")),
        []
    );
    function endSession(reload = true) {
        const finalData = {
            ConsumerId: id,
            CustomerId: user.CustomerId,
            Action: "Session Ended",
        };
        axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/storeWhiteLabelConsumerDetails`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: finalData,
        })
            .then((res) => {
                if (res.data.message === "UnAuthorized") {
                    localStorage.clear();
                    window.location.reload(true);
                }
            })
            .catch((err) => { });

        // end consumer session
        if (consumerSessionId && consumerSessionId > 0) {
            axios({
                method: "POST",
                url: `${NODE_API_URL}/ccmode/ccmode-end-session`,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem(
                        "accessToken"
                    )}`,
                },
                data: {
                    consumerSessionId: consumerSessionId,
                    closeAction: "End Session Button",
                },
            })
                .then((res) => {
                    if (res.data.message === "UnAuthorized") {
                        localStorage.clear();
                        window.location.reload(true);
                    }
                })
                .catch((err) => { });
        }

        window.localStorage.setItem("C_id", -1);
        localStorage.removeItem("consumerSessionId");
        localStorage.removeItem("consumerSessionCurrency");

        if (reload) {
            setTimeout(() => {
                setTimeout(() => {
                    window.location.reload(true);
                }, 100);
                history.push({ pathname: "/searchdiamond" });
            }, 500);
        }
    }

    const [showModel, setShowModel] = useState(false);
    useEffect(() => {
        if (window.localStorage.getItem("sessionStartedToastShown") === "false") {
            window.localStorage.setItem("sessionStartedToastShown", "true");
            toast.info("Session Started.");
        }

        if (consumerSessionDetails && consumerSessionDetails?.blockSession) {
            setShowModel(true);
        }


    }, [consumerSessionDetails])

    if (location.pathname.startsWith("/invite/")) {
        return (
            <Modal
                show={true}
                // onHide={closeSessionModal}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <Modal.Body>
                    <div className="col-12 text-capitalize">
                        <h5 className="text-center">
                            already logged in with another account
                        </h5>
                        <hr className="w-100" />
                        <p className="text-center font-size-h5">
                            Another account is currently logged in. Please log
                            out to complete setup or continue with the current
                            session.
                        </p>
                        <div className="m-6 text-center">
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip">
                                        Ends current session and proceeds with
                                        setup.
                                    </Tooltip>
                                }
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="mr-10"
                                    onClick={() => {
                                        localStorage.clear();
                                        history.go(0);
                                    }}
                                >
                                    Log Out
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip">
                                        Continues with the active session.
                                    </Tooltip>
                                }
                            >
                                <Button
                                    variant="outlined"
                                    onClick={() => history.push("/")}
                                >
                                    Continue
                                </Button>
                            </OverlayTrigger>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
    if (location.pathname.startsWith("/delete-account")) {
        return (
            <Modal
                show={true}
                // onHide={closeSessionModal}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <Modal.Body>
                    <div className="col-12 text-capitalize">
                        <h5 className="text-center">
                            already logged in with another account
                        </h5>
                        <hr className="w-100" />
                        <p className="text-center font-size-h5">
                            Another account is currently logged in. Please log
                            out to delete account or continue with the current
                            session.
                        </p>
                        <div className="m-6 text-center">
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip">
                                        Ends current session and proceeds with
                                        delete account.
                                    </Tooltip>
                                }
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="mr-10"
                                    onClick={() => {
                                        localStorage.clear();
                                        history.go(0);
                                    }}
                                >
                                    Log Out
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip">
                                        Continues with the active session.
                                    </Tooltip>
                                }
                            >
                                <Button
                                    variant="outlined"
                                    onClick={() => history.push("/")}
                                >
                                    Continue
                                </Button>
                            </OverlayTrigger>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    if (new URLSearchParams(location.search).has("autoLoginToken")) {
        localStorage.clear();
        history.go(0);
    }

    if (showModel) {
        return <div className="d-flex flex-column flex-root" style={{ minHeight: "100vh" }}>
            <div className="error error-6 d-flex flex-row-fluid bgi-size-cover bgi-position-center">

                {/* Adjusted padding: p-4 for mobile, p-sm-10 for larger screens */}
                <div className="d-flex flex-column flex-row-fluid justify-content-center align-items-center p-4 p-sm-10">

                    {/* Card UI */}
                    <div
                        className="card shadow-lg border-0"
                        style={{
                            width: "100%",
                            maxWidth: "800px",
                            borderRadius: "12px",
                            backgroundColor: "rgba(255, 255, 255, 0.95)"
                        }}
                    >
                        {/* Adjusted padding: p-6 for mobile, p-sm-12 for larger screens */}
                        <div className="card-body text-center p-6 p-sm-12 d-flex flex-column justify-content-center align-items-center">

                            <h2 className="font-weight-bolder text-dark mb-4 text-uppercase">
                                Warning!
                            </h2>

                            <IoIosWarning style={{
                                fontSize: "60px",
                                color: themeData.NaturalPrimaryColor,
                                marginBottom: "1rem"
                            }} />

                            <p className="lead text-capitalize mb-10">
                                {consumerSessionDetails?.blockSessionReason || "Your session has been blocked."}
                            </p>

                            {/* Button Container: Stacks vertically on mobile (flex-column), horizontally on sm+ (flex-sm-row) */}
                            <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center w-100">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className="mb-3 mb-sm-0 mr-0 mr-sm-8 w-100"
                                    style={{
                                        maxWidth: "150px",
                                        borderColor: themeData.NaturalPrimaryColor,
                                        color: themeData.NaturalPrimaryColor,
                                        backgroundColor: `${themeData.NaturalPrimaryColor}10`
                                    }}
                                    onClick={() => {
                                        endSession();
                                    }}
                                >
                                    Back to Home
                                </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="w-100"
                                    style={{
                                        maxWidth: "150px",
                                        backgroundColor: themeData.NaturalPrimaryColor,
                                        color: themeData.NaturalFontColor
                                    }}
                                    onClick={() => {
                                        endSession(false);
                                        openSessionModal();
                                    }}
                                >
                                    Start New Session
                                </Button>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    }

    return layoutProps.selfLayout !== "blank" ? (
        <>
            {/*begin::Main*/}
            <HeaderMobile />
            <div className="d-flex flex-column flex-root">
                {/*begin::Page*/}
                <div className="d-flex flex-row flex-column-fluid page">
                    {layoutProps.asideDisplay && <Aside />}
                    {/*begin::Wrapper*/}
                    <div
                        className="d-flex flex-column flex-row-fluid wrapper"
                        id="kt_wrapper"
                    >
                        <Header language={language} themeData={themeData} translationsVersion={translationsVersion}/>
                        {/*begin::Content*/}
                        <div
                            id="kt_content"
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
                        >
                            {layoutProps.subheaderDisplay && <SubHeader />}
                            {/*begin::Entry*/}
                            {!layoutProps.contentExtended && (
                                <div className="d-flex flex-column-fluid">
                                    {/*begin::Container*/}
                                    <div
                                        className={
                                            layoutProps.contentContainerClasses
                                        }
                                    >
                                        {children}
                                    </div>
                                    {/*end::Container*/}
                                </div>
                            )}

                            {layoutProps.contentExtended && { children }}
                            {/*end::Entry*/}
                        </div>
                        {/*end::Content*/}
                        {/* <Footer/> */}
                    </div>
                    {/*end::Wrapper*/}
                </div>
                {/*end::Page*/}
            </div>
            <QuickUser />
            {/* <QuickPanel/> */}
            <ScrollTop />
            {/* <StickyToolbar/> */}
            {/*end::Main*/}
            <LayoutInit />
        </>
    ) : (
        // BLANK LAYOUT
        <div className="d-flex flex-column flex-root">{children}</div>
    );
}
